export function quickNoteTaskContent(body: string): { title: string; description: string } {
  const lines = body.replace(/\r\n/g, "\n").split("\n");
  const index = lines.findIndex(line => line.trim());
  if (index < 0) return { title: "", description: "" };
  const source = lines[index].trim();
  const title = source.slice(0, 240);
  const remainder = source.slice(240);
  const descriptionLines = [...lines.slice(0, index), ...(remainder ? [remainder] : []), ...lines.slice(index + 1)];
  return { title, description: descriptionLines.join("\n").trim() };
}
